import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import BarChart from '../common/Charts/BarChart';
import PieChart from '../common/Charts/PieChart';
import {
  processData,
  IMAGES,
  checkAsterickFormate,
  labelToolTips,
  filterAsterisk,
} from '../../util/QuickReportsUtils';
import {
  MODULE_DIGITAL_ACTIVITY_PROFILE,
  MOBILE_SEGMENT_COMPOSITION,
  MOBILITY_ADOPTION,
} from '../../constants';
import QuickReportFootNote from './QuickReportFootNotes';

const DAP_LABEL_FORMATER = {
  Computer: IMAGES.ICON_pc_blue,
  Television: IMAGES.ICON_television,
  'Cellphone or Tablet': IMAGES.ICON_tablet,
};

const AOM_LABEL_FORMATER = {
  Airports: IMAGES.ICON_airport,
  Home: IMAGES.ICON_home,
  Hotels: IMAGES.ICON_hotel,
  Library: IMAGES.ICON_library,
  Restaurants: IMAGES.ICON_restaurant,
  School: IMAGES.ICON_school,
  Work: IMAGES.ICON_work,
};

const BAR_LAVEL_FORMATER = {
  Camera: `<img width="40px" src=${IMAGES.ICON_camera} /> Camera`,
  'Download App': `<img width="40px" src=${IMAGES.ICON_gaming_console} /> Download App`,
  'E-mail': `<img width="40px" src=${IMAGES.ICON_email} /> E-mail`,
  GPS: `<img width="40px" src=${IMAGES.ICON_GPS} /> GPS`,
  'IM/Chat': `<img width="40px" src=${IMAGES.ICON_chat} /> IM/Chat`,
  'Listen to Music': `<img width="40px" src=${IMAGES.ICON_listen} /> Listen to Music`,
  Message: `<img width="40px" src=${IMAGES.ICON_smartphone} /> Message`,
  'Play Games': `<img width="40px" src=${IMAGES.ICON_gamingConsole} /> Play Games`,
  'Read Media': `<img width="40px" src=${IMAGES.ICON_newspaper} /> Read Media`,
  'Social Network': `<img width="40px" src=${IMAGES.ICON_socialNetwork} /> Social Network`,
  Talk: `<img width="40px" src=${IMAGES.ICON_talk} /> Talk`,
  Video: `<img width="40px" src=${IMAGES.ICON_stream_video} /> Video`,
  'Visit Websites': `<img width="40px" src=${IMAGES.ICON_television} /> Visit Websites`,
};
const filterValue = (label, value) => {
  let res = value.index || value.other;

  if (
    label === 'Married' &&
    Math.round(Number(value.pct.replace(/%/g, ''))) === 0
  ) {
    res = 'NA';
  }
  if (value.sample < 31) {
    res = `**${value.index}` || `**${value.other}`;
  } else if (value.sample < 61) {
    res = `*${value.index}` || `*${value.other}`;
  }

  return res;
};

const renderGeneralTable = (data, isDoubleAsterik, isSingleAsterik) => (
  <table className="general-stats-table">
    <tbody>
      {data.map(({ label, value }) => (
        <tr key={uuid()}>
          <td
            title={labelToolTips(
              label,
              value.sample,
              value.weighted,
              value.pct,
              value.index,
              isSingleAsterik,
              isDoubleAsterik
            )}
          >
            <img src={AOM_LABEL_FORMATER[label]} alt={label} />
            {label}
          </td>
          <td
            className="label-text"
            title={labelToolTips(
              label,
              value.sample,
              value.weighted,
              value.pct,
              value.index,
              isSingleAsterik,
              isDoubleAsterik
            )}
          >
            {filterValue(label, value)}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default class DigitalActivityProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSingleAsterisk: false,
      showDoubleAsterisk: false,
      color: [
        '#247BA0',
        '#F25F5C',
        '#FFE066',
        '#4ECDC4',
        '#008490',
        '#F67451',
        '#E1D2A5',
        '#94D3DC',
        '#5CA4A9',
        '#FAB266',
      ],
    };
  }

  componentDidMount() {
    // console.log(" Data from the "+this.props.data['Smartphone Activity Index']);
    this.props.handletitle('Digital Activity Profile');
    this.props.handleExportParams();
    this.props.trackerFn({ subModule: MODULE_DIGITAL_ACTIVITY_PROFILE });
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps() {
    this.state.showSingleAsterisk = false;
    this.state.showDoubleAsterisk = false;
  }

  updateAsteriskStatus = asterisk => {
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  render() {
    return (
      <div className="large-12 quick-report-graph-wrapper border-0">
        <div className="large-12">
          <div className="column large-3 padding-0">
            <div className="quick-report-cards internet-location-img">
              <h4>Internet Location Access Most Often</h4>
              {renderGeneralTable(
                this.props.data['Most Used Location'],
                this.state.showDoubleAsterisk,
                this.state.showSingleAsterisk
              )}
            </div>
          </div>
          <div className="column large-9 padding-0">
            <div className="large-12">
              <div className="column large-6 padding-0">
                <div className="quick-report-cards min-height-250">
                  <h4> Internet at Home: Usage Access </h4>
                  {this.props.data['Home Usage Access'].map(item => (
                    <div
                      key={uuid()}
                      className="large-4 column text-center end"
                      title={`${item.label} \nSample: ${item.value.sample} \nWeighted: ${item.value.weighted} \nPercent: ${item.value.pct} \nIndex: ${item.value.index}`}
                    >
                      <div
                        className="social-media-profile-icon"
                        title={labelToolTips(
                          item.label,
                          item.value.sample,
                          item.value.weighted,
                          item.value.pct,
                          item.value.index,
                          this.state.showSingleAsterisk,
                          this.state.showDoubleAsterisk
                        )}
                      >
                        <img
                          src={DAP_LABEL_FORMATER[item.label]}
                          role="presentation"
                          alt="presentation"
                        />
                      </div>
                      <div className="social-media-profile-icon-label">
                        <div
                          className="label-item"
                          title={labelToolTips(
                            item.label,
                            item.value.sample,
                            item.value.weighted,
                            item.value.pct,
                            item.value.index,
                            this.state.showSingleAsterisk,
                            this.state.showDoubleAsterisk
                          )}
                        >
                          {item.label}
                        </div>
                        <div
                          className="label-text"
                          title={labelToolTips(
                            item.label,
                            item.value.sample,
                            item.value.weighted,
                            item.value.pct,
                            item.value.index,
                            this.state.showSingleAsterisk,
                            this.state.showDoubleAsterisk
                          )}
                        >
                          {filterAsterisk(item)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="column large-6 padding-0">
                <div
                  className="quick-report-cards"
                  style={{ overflow: 'hidden' }}
                >
                  <PieChart
                    chartTitle={
                      Object.keys(this.props.data).some(
                        item => item === MOBILE_SEGMENT_COMPOSITION
                      )
                        ? MOBILE_SEGMENT_COMPOSITION
                        : MOBILITY_ADOPTION
                    }
                    chartColor={this.state.color}
                    chartLegend={{
                      align: 'right',
                      verticalAlign: 'top',
                      layout: 'vertical',
                      x: 0,
                      y: 40,
                     
                      itemMarginBottom: 10,
                    }}
                    pieChartHeight={250}
                    data={{
                      tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
                      processedData: processData(
                        {
                          rawData: Object.keys(this.props.data).some(
                            item => item === MOBILE_SEGMENT_COMPOSITION
                          )
                            ? this.props.data[MOBILE_SEGMENT_COMPOSITION]
                            : this.props.data[MOBILITY_ADOPTION],
                        },
                        this.updateAsteriskStatus,
                        this.props.study
                      ),
                    }}
                    dataLabelFormat={checkAsterickFormate(
                      '{y}%',
                      this.state.showDoubleAsterisk,
                      this.state.showSingleAsterisk
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="column large-12 padding-0">
              <div className="quick-report-cards">
                <BarChart
                  chartTitle="Smartphone Activity Index"
                  chartType="column"
                  chartColor={this.state.color}
                  barChartHeight={265}
                  yLabel="value"
                  data={{
                    tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
                    processedData: processData(
                      {
                        rawData: this.props.data['Smartphone Activity Index'],
                        y: 'index',
                      },
                      this.updateAsteriskStatus,
                      this.props.study
                    ),
                  }}
                  labelFormatter={BAR_LAVEL_FORMATER}
                  dataLabels
                  dataLabelFormat={checkAsterickFormate(
                    '{y}',
                    this.state.showDoubleAsterisk,
                    this.state.showSingleAsterisk
                  )}
                />
              </div>
            </div>
          </div>
          <p>&nbsp;</p>
        </div>
        <QuickReportFootNote
          studyInfo={this.props.study}
          className="font-12 clearfix"
          showSingleAsterisk={this.state.showSingleAsterisk}
          showDoubleAsterisk={this.state.showDoubleAsterisk}
        />
      </div>
    );
  }
}

DigitalActivityProfile.propTypes = {
  data: PropTypes.shape({
    detailGroups: PropTypes.arrayOf(
      PropTypes.shape({
        'Home Usage Access': PropTypes.arrayOf(PropTypes.shape({})),
      })
    ),
  }),
  handletitle: PropTypes.func,
  handleExportParams: PropTypes.func,
  trackerFn: PropTypes.func,
  study: PropTypes.shape({}),
};
